import { PopupSize, PopupTemplate } from "../molecules";

export const PopupWarningDisplayStrategyForbiddenOperation = (props: {
  handleClosePopup: () => void;
}) => {
  const { handleClosePopup } = props;
  return (
    <PopupTemplate
      {...{
        title: "Operation Not Allowed",
        description: "Can't remove or reorder section/question that has display strategy applied.",
        background: true,
        handleClosePopup,
        mainFunction: handleClosePopup,
        buttonContent: "OK",
        popupSize: PopupSize.Small,
        hideCancelButton: true,
        zIndex: 1000,
      }}
    />
  );
};
